// link
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// @ts-ignore
import Cookies from "js-cookie";

const Footer = (props: any) => {
    const [user, setUser] = useState<object | any>();

    useEffect(() => {
        let user: any = Cookies.get("userData");

        if (user) {
            user = JSON.parse(user);
            setUser(user);
        }
    }, []);

    const isIranTarakonesh =
        Cookies.get("irt") === "true" ||
        user?.returnUrl === "https://" ||
        user?.returnUrl === null;

    const returnLink = isIranTarakonesh
        ? "https://irantarakonesh.ir/"
        : user?.returnUrl;

    return (
        <>
            <div className="d-flex justify-content-center mb-2 mt-4">

                <Link
                    id="share"
                    to={returnLink}
                    className="dark-green text-white font-medium mb-2 py-2 me-2 rounded-pill align-middle font-medium btn-site-green btn fw-bold"
                >
                    {isIranTarakonesh
                        ? "ورود به ایران تراکنش"
                        : `بازگشت به ${user?.irtName}`}
                </Link>
                {props.status ? (
                    <>
                        <button
                            data-bs-toggle="modal"
                            data-bs-target="#modal-payment"
                            className="dark-green me-2 mb-2 rounded-pill align-middle font-medium btn-site btn fw-bold"
                        >
                            اشتراک گذاری رسید
                        </button>
                    </>
                ) : null}

            </div>
        </>
    );
};

export default Footer;
